import { h, render } from 'preact';
import LegeViewer from './components/lege-viewer';
import RelatedStories from './components/related-stories';
import AdLoader from './utils/ad-loader';
import './utils/trackers';

const viewerContainer = document.getElementById('stream-viewer-container');

render(<LegeViewer />, viewerContainer, viewerContainer.lastElementChild);

/**
 * This is the loader managing the primary related content feed. It uses the
 * `subject-85th-legislative-session` Guten tag.
 */
render(
  <RelatedStories src="https://www.texastribune.org/api/v1/content/?content_type=story,audio,video,pointer&amp;tag=subject-85th-legislative-session&amp;fields=id,url,readable_pub_date,seo_headline,short_summary,lead_art&amp;limit=8&amp;format=json" />,
  document.getElementById('related-stories-grid')
);

/**
 * These renderers are what power the other related content sections. If any
 * changes are going to be made, they are most likely going to happen here.
 *
 * Each one gets entered in the element passed at the end of the renderer. If
 * you have to add more, there are others to uncomment below. Make sure they
 * also have an HTML element to load into!
 */
render(
  <RelatedStories isColumn title="Bathroom bill" tag="subject-bathroom-bill" />,
  document.getElementById('top-topics-grid-1')
);

render(
  <RelatedStories
    isColumn
    title="Public education"
    tag="subject-public-education"
  />,
  document.getElementById('top-topics-grid-2')
);

// A template for any new ones.
//
// render(
//   <RelatedStories
//     isColumn
//     title=""
//     tag=""
//   />,
//   document.getElementById('top-topics-grid-3')
// );

/**
 * This handles the loading of the ads on the page.
 * @type {Object}
 */
const adLoader = AdLoader({
  targetingValue: '85th-lege',
});
adLoader.init();



// WEBPACK FOOTER //
// ./main.js